import {
  Grid,
  FormLabel,
  FormControl,
  TextField,
  MenuItem,
  Box,
  Button,
  Divider,
} from "@mui/material";

import React, { useEffect, useCallback, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { yupResolver } from "@hookform/resolvers/yup";
import { bulkAppointmentValidation } from "../../utils/Validation";
import { Add, Delete, Save } from "@material-ui/icons";
import useGlobalState from "../../Context";
import {
  getVehicleTypeCall,
  getMaterialTypeCall,
} from "../../services/VendorAppointmentBook";
import { VendorBulkAppointment } from "../../services/BulkAppointmentSevice";
import { setMaterialList, setVehicleList } from "../../reducer/action";
import { useNotificationContext } from "../../common/NotificationContext";
import { useLoading } from "../../common/LoadingContext";
import { pad, isDateGreaterThan } from "../../utils/jsUtils";

const AddNew = ({ handleChange }) => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const formOption = {
    resolver: yupResolver(bulkAppointmentValidation),
    defaultValues: {},
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm(formOption);
  const { fields, append, remove } = useFieldArray({
    name: "appointment",
    control,
  });
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);
  const currentMaxDate = new Date();
  currentMaxDate.setDate(currentMaxDate.getDate() + 10);
  const [totalAppointment, setTotalAppointment] = useState(1);
  const [{ vehicleList, materialList }, dispatch] = useGlobalState();

  const dateChangeinDDMMYYYY = (date) => {
    if (date) {
      const parsedDate = new Date(date);
      const dateString = [
        pad(parsedDate.getDate()),
        pad(parsedDate.getMonth() + 1),
        parsedDate.getFullYear(),
      ].join("-");
      return dateString;
    }
    return "-";
  };

  const checkDateValid = () => {
    let temp = getValues("appointment").map((item) =>
      isDateGreaterThan(item.appointmentDate, currentDate) === null
        ? false
        : isDateGreaterThan(item.appointmentDate, currentDate) &&
          isDateGreaterThan(currentMaxDate, item.appointmentDate)
    );
    if (temp.includes(false)) {
      setErrorMsg(temp);
    }
    return !temp.includes(false);
  };

  const getMaterialType = useCallback(async () => {
    try {
      setLoading(true);
      const resp = await getMaterialTypeCall(baseUrl);
      if (resp?.messageCode === 6) {
        dispatch(setMaterialList(resp.materialTypeParams));
      } else {
        showNotification(
          "Error",
          resp?.message ?? "Failed To Get Material Type"
        );
        dispatch(setMaterialList(resp.materialTypeParams));
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Get Material Type");
    } finally {
      setLoading(false);
    }
  }, [dispatch, setLoading, showNotification, baseUrl]);
  const getVehicleType = useCallback(async () => {
    try {
      setLoading(true);
      const resp = await getVehicleTypeCall(baseUrl);
      if (resp?.messageCode === 6) {
        dispatch(setVehicleList(resp.vehicleTypeParams));
      } else {
        showNotification(
          "Error",
          resp?.message ?? "Failed To Get Vehicle Type"
        );
        dispatch(setVehicleList(resp.vehicleTypeParams));
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Get Vehicle Type");
    } finally {
      setLoading(false);
    }
  }, [dispatch, setLoading, showNotification, baseUrl]);
  const onSubmit = async (data) => {
    let objList = data.appointment.map((item, index) => {
      return {
        ...item,
        appointmentDate: dateChangeinDDMMYYYY(item.appointmentDate),
      };
    });
    if (checkDateValid()) {
      try {
        setLoading(true);
        const resp = await VendorBulkAppointment(baseUrl, {
          appointments: objList,
        });
        if (resp?.messageCode === 6) {
          reset();
          showNotification(
            "Success",
            resp?.message ?? "Added successfuly",
            "success"
          );
          handleChange("", 0);
        } else {
          showNotification(
            "Error",
            resp?.message ?? "Failed To add appointment"
          );
        }
      } catch (err) {
        showNotification("Error", err?.message ?? "Failed To add appointment");
      } finally {
        setLoading(false);
      }
    }
  };
  const setErrorMsg = (list) => {
    list.forEach((item, index) => {
      if (item === false) {
        setError(`appointment[${index}].appointmentDate`, {
          type: "manual",
          message: "Please enter Valid Date",
        });
      } else {
        clearErrors(`appointment[${index}].appointmentDate`);
      }
    });
  };
  const initialLoad = useCallback(async () => {
    if (
      vehicleList === undefined ||
      vehicleList === null ||
      vehicleList?.length === 0
    ) {
      await getVehicleType();
    }
    if (
      materialList === undefined ||
      materialList === null ||
      materialList?.length === 0
    ) {
      await getMaterialType();
    }
  }, [getMaterialType, getVehicleType, materialList, vehicleList]);

  useEffect(() => {
    initialLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const newVal = parseInt(totalAppointment);
    const oldVal = fields?.length;
    if (newVal > oldVal) {
      for (let i = oldVal; i < newVal; i++) {
        append({
          poNumber: "",
          gstIn: "",
          appointmentDate: "",
          noOfCases: "",
          materialTypeId: "",
          countOfSkus: "",
          vehicleTypeId: "",
          vrn: "",
          driverName: "",
          driverContactNumber: "",
        });
      }
    }
  }, [append, fields.length, totalAppointment, setValue]);

  return (
    <Box display={"flex"} justifyContent="center" sx={{ pt: 1 }}>
      <form>
        <Grid container spacing={1}>
          {fields?.map((val, index) => {
            return (
              <>
                <Grid
                  sx={{ m: 1, p: 1, backgroundColor: "#c7c7c73b" }}
                  container
                  spacing={2}
                >
                  <Grid item xs={12} sm={11 / 5}>
                    <FormLabel sx={{ float: "left", fontSize: 13 }}>
                      PO Number
                    </FormLabel>
                    <FormControl sx={{ width: "100%", textAlign: "left" }}>
                      <TextField
                        InputProps={{ sx: { backgroundColor: "#ffffff" } }}
                        id=""
                        placeholder="Po Number"
                        name={`appointment[${index}]poNumber`}
                        size="small"
                        className="input-correction"
                        {...register(`appointment.${index}.poNumber`, {
                          required: true,
                        })}
                        error={
                          !!errors?.appointment?.[index]?.poNumber
                            ? Boolean(
                                `${errors?.appointment?.[index]?.poNumber}`
                              )
                            : false
                        }
                        helperText={
                          !!errors?.appointment?.[index]?.poNumber
                            ? `${errors?.appointment?.[index]?.poNumber?.message}`
                            : ""
                        }
                      ></TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={11 / 5}>
                    <FormLabel sx={{ float: "left", fontSize: 13 }}>
                      GST IN
                    </FormLabel>
                    <FormControl sx={{ width: "100%", textAlign: "left" }}>
                      <TextField
                        InputProps={{ sx: { backgroundColor: "#ffffff" } }}
                        id=""
                        placeholder="GST IN"
                        name={`appointment[${index}]gstIn`}
                        className="input-correction"
                        {...register(`appointment.${index}.gstIn`, {
                          required: true,
                        })}
                        size="small"
                        error={
                          !!errors?.appointment?.[index]?.gstIn
                            ? Boolean(`${errors?.appointment?.[index]?.gstIn}`)
                            : false
                        }
                        helperText={
                          !!errors?.appointment?.[index]?.gstIn
                            ? `${errors?.appointment?.[index]?.gstIn?.message}`
                            : ""
                        }
                      ></TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={11 / 5}>
                    <FormLabel sx={{ float: "left", fontSize: 13 }}>
                      Appointment Date
                    </FormLabel>
                    <FormControl sx={{ width: "100%", textAlign: "left" }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          InputProps={{ sx: { backgroundColor: "#ffffff" } }}
                          {...register(`appointment.${index}.appointmentDate`, {
                            required: true,
                          })}
                          defaultCalendarMonth={currentDate}
                          value={
                            getValues(`appointment[${index}]appointmentDate`) ||
                            null
                          }
                          minDate={currentDate}
                          maxDate={currentMaxDate}
                          name={`appointment[${index}]appointmentDate`}
                          inputFormat="dd/MM/yyyy"
                          onChange={(newValue) => {
                            setValue(
                              `appointment.${index}.appointmentDate`,
                              newValue,
                              {
                                shouldValidate: true,
                                shouldDirty: true,
                              }
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              InputProps={{
                                sx: { backgroundColor: "#ffffff" },
                              }}
                              id={`appointment[${index}]appointmentDate`}
                              size="small"
                              {...params}
                              error={
                                !!errors?.appointment?.[index]?.appointmentDate
                                  ? Boolean(
                                      `${errors?.appointment?.[index]?.appointmentDate}`
                                    )
                                  : false
                              }
                              helperText={
                                !!errors?.appointment?.[index]?.appointmentDate
                                  ? `${errors?.appointment?.[index]?.appointmentDate?.message}`
                                  : ""
                              }
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={11 / 5}>
                    <FormLabel sx={{ float: "left", fontSize: 13 }}>
                      Number Of Cases
                    </FormLabel>
                    <FormControl sx={{ width: "100%", textAlign: "left" }}>
                      <TextField
                        InputProps={{ sx: { backgroundColor: "#ffffff" } }}
                        id=""
                        placeholder="Number Of Cases"
                        name={`appointment[${index}]noOfCases`}
                        className="input-correction"
                        {...register(`appointment.${index}.noOfCases`, {
                          required: true,
                        })}
                        size="small"
                        error={
                          !!errors?.appointment?.[index]?.noOfCases
                            ? Boolean(
                                `${errors?.appointment?.[index]?.noOfCases}`
                              )
                            : false
                        }
                        helperText={
                          !!errors?.appointment?.[index]?.noOfCases
                            ? `${errors?.appointment?.[index]?.noOfCases?.message}`
                            : ""
                        }
                      ></TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={11 / 5}>
                    <FormLabel sx={{ float: "left", fontSize: 13 }}>
                      Count Of Skus
                    </FormLabel>
                    <FormControl sx={{ width: "100%", textAlign: "left" }}>
                      <TextField
                        InputProps={{ sx: { backgroundColor: "#ffffff" } }}
                        id=""
                        placeholder="Count Of Skus"
                        name={`appointment[${index}]countOfSkus`}
                        className="input-correction"
                        {...register(`appointment.${index}.countOfSkus`, {
                          required: true,
                        })}
                        size="small"
                        error={
                          !!errors?.appointment?.[index]?.countOfSkus
                            ? Boolean(
                                `${errors?.appointment?.[index]?.countOfSkus}`
                              )
                            : false
                        }
                        helperText={
                          !!errors?.appointment?.[index]?.countOfSkus
                            ? `${errors?.appointment?.[index]?.countOfSkus?.message}`
                            : ""
                        }
                      ></TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={1}>
                    {totalAppointment > 1 && (
                      <Button
                        variant="text"
                        size="small"
                        color="error"
                        sx={{ mr: 2, mt: 3 }}
                        onClick={() => {
                          remove(index);
                          setTotalAppointment((prevValue) => prevValue - 1);
                        }}
                      >
                        <Delete />
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={11 / 5}>
                    <FormLabel sx={{ float: "left", fontSize: 13 }}>
                      Material Type
                    </FormLabel>
                    <FormControl sx={{ width: "100%", textAlign: "left" }}>
                      <TextField
                        InputProps={{ sx: { backgroundColor: "#ffffff" } }}
                        name={
                          (`appointment[${index}]materialTypeId`,
                          { required: true })
                        }
                        className="input-correction"
                        defaultValue={val?.materialTypeId}
                        select
                        fullWidth
                        style={{ textAlign: "start" }}
                        size="small"
                        autoComplete="off"
                        {...register(`appointment[${index}].materialTypeId`)}
                        error={
                          !!errors?.appointment?.[index]?.materialTypeId
                            ? Boolean(
                                `${errors?.appointment?.[index]?.materialTypeId}`
                              )
                            : false
                        }
                        helperText={
                          !!errors?.appointment?.[index]?.materialTypeId
                            ? `${errors?.appointment?.[index]?.materialTypeId?.message}`
                            : ""
                        }
                      >
                        {materialList?.length > 0 &&
                          materialList.map((option) => (
                            <MenuItem
                              key={option.materialTypeId}
                              value={option.materialTypeId}
                            >
                              {option.materialType}
                            </MenuItem>
                          ))}
                      </TextField>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={11 / 5}>
                    <FormLabel sx={{ float: "left", fontSize: 13 }}>
                      Vehicle Type
                    </FormLabel>
                    <FormControl sx={{ width: "100%", textAlign: "left" }}>
                      <TextField
                        InputProps={{ sx: { backgroundColor: "#ffffff" } }}
                        name={`appointment[${index}]vehicleTypeId`}
                        select
                        fullWidth
                        size="small"
                        defaultValue={val?.vehicleTypeId}
                        autoComplete="off"
                        {...register(`appointment[${index}].vehicleTypeId`)}
                        error={
                          !!errors?.appointment?.[index]?.vehicleTypeId
                            ? Boolean(
                                `${errors?.appointment?.[index]?.vehicleTypeId}`
                              )
                            : false
                        }
                        helperText={
                          !!errors?.appointment?.[index]?.vehicleTypeId
                            ? `${errors?.appointment?.[index]?.vehicleTypeId?.message}`
                            : ""
                        }
                      >
                        {vehicleList?.length > 0 &&
                          vehicleList?.map((option) => (
                            <MenuItem
                              key={option.vehicleTypeId}
                              value={option.vehicleTypeId}
                            >
                              {option.vehicleType}
                            </MenuItem>
                          ))}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={11 / 5}>
                    <FormLabel sx={{ float: "left", fontSize: 13 }}>
                      Vehicle Reg. Number
                    </FormLabel>
                    <FormControl sx={{ width: "100%", textAlign: "left" }}>
                      <TextField
                        InputProps={{ sx: { backgroundColor: "#ffffff" } }}
                        id=""
                        placeholder="Vehicle Registeration Number"
                        name={`appointment[${index}]vrn`}
                        className="input-correction"
                        {...register(`appointment.${index}.vrn`, {
                          required: true,
                        })}
                        size="small"
                        error={
                          !!errors?.appointment?.[index]?.vrn
                            ? Boolean(`${errors?.appointment?.[index]?.vrn}`)
                            : false
                        }
                        helperText={
                          !!errors?.appointment?.[index]?.vrn
                            ? `${errors?.appointment?.[index]?.vrn?.message}`
                            : ""
                        }
                      ></TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={11 / 5}>
                    <FormLabel sx={{ float: "left", fontSize: 13 }}>
                      Driver Name
                    </FormLabel>
                    <FormControl sx={{ width: "100%", textAlign: "left" }}>
                      <TextField
                        InputProps={{ sx: { backgroundColor: "#ffffff" } }}
                        id=""
                        placeholder="Driver Name"
                        name={`appointment[${index}]driverName`}
                        className="input-correction"
                        {...register(`appointment.${index}.driverName`, {
                          required: true,
                        })}
                        size="small"
                        error={
                          !!errors?.appointment?.[index]?.driverName
                            ? Boolean(
                                `${errors?.appointment?.[index]?.driverName}`
                              )
                            : false
                        }
                        helperText={
                          !!errors?.appointment?.[index]?.driverName
                            ? `${errors?.appointment?.[index]?.driverName?.message}`
                            : ""
                        }
                      ></TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={11 / 5}>
                    <FormLabel sx={{ float: "left", fontSize: 13 }}>
                      Driver Contact Number
                    </FormLabel>
                    <FormControl sx={{ width: "100%", textAlign: "left" }}>
                      <TextField
                        InputProps={{ sx: { backgroundColor: "#ffffff" } }}
                        id=""
                        placeholder="Driver Contact Number"
                        name={`appointment[${index}]driverContactNumber`}
                        className="input-correction"
                        {...register(
                          `appointment.${index}.driverContactNumber`,
                          {
                            required: true,
                          }
                        )}
                        size="small"
                        error={
                          !!errors?.appointment?.[index]?.driverContactNumber
                            ? Boolean(
                                `${errors?.appointment?.[index]?.driverContactNumber}`
                              )
                            : false
                        }
                        helperText={
                          !!errors?.appointment?.[index]?.driverContactNumber
                            ? `${errors?.appointment?.[index]?.driverContactNumber?.message}`
                            : ""
                        }
                      ></TextField>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  display={"flex"}
                  justifyContent="flex-end"
                  item
                  xs={12}
                  sm={12}
                >
                  {fields?.length === index + 1 ? (
                    <Button
                      size="small"
                      color="success"
                      variant="outlined"
                      startIcon={<Add />}
                      onClick={() => {
                        setTotalAppointment((prevValue) => prevValue + 1);
                      }}
                      sx={{ px: 1 }}
                    >
                      Add New
                    </Button>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider />
                </Grid>
              </>
            );
          })}
          <Grid item xs={12} mt={1} display="flex" justifyContent="end">
            <Button
              size="medium"
              startIcon={<Save />}
              variant="contained"
              onClick={handleSubmit(onSubmit)}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default AddNew;
